import { Box, Button } from "@mui/material";
import React from "react";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Grid from "@mui/material/Grid";
import TodayIcon from "@mui/icons-material/Today";
import DatePicker from "../common/DatePicker";

export default function LandDate(props) {
  return (
    <div className="land-date-container">
      <Box mt={0} width="100%" align="center">
        <h2 className="sectionTitle center">Date Land</h2>
        <Grid container justifyContent="center" alignItems="center" spacing={1}>
          <Grid item xs={12} md="auto">
            <Box m={2}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                className="form-input"
                size="large"
                onClick={(e) => props.landDateNowHandler(e)}
                key={"land_date_now"}
                startIcon={<TodayIcon />}
              >
                {"Now"}
              </Button>
            </Box>
          </Grid>
          <Grid item xs={12} md="auto">
            <DatePicker
              label="Land Date"
              displayDate={props.display_land_date}
              class={"land_date"}
              handleDateChange={props.handleLandDateChange}
              name={"land_date"}
              dateHelperText="Enter date and time landed"
            />
            <HelpText helpText={getHelpText(props.helpText, "land_date")} />
          </Grid>
        </Grid>
      </Box>
    </div>
  );
}
